import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image/mobile-app-store-badge.png")